import {getShoppingSubscriptionResultInfo} from '@web/actions/result'
import {PaymoneyDisplayBankNameMap, PaymoneyMemberType} from '@web/slices/chargePoint/slice'
import makeSlice from '@web/slices/chargePoint/sliceMaker'

import {fetchSubscription} from '../../actions'

const slice = makeSlice({
    extraReducers(builder) {
        builder
            .addCase(fetchSubscription.fulfilled, (state, {payload: {subscriptionViewResult}}) => {
                /** 아래 state의 initial 값이 NOT_OPEN  */
                state.payMoney.userStatus = subscriptionViewResult.chargePointUser.userStatus ?? 'NOT_OPEN'
                state.payMoney.bankCode =
                    subscriptionViewResult.chargePointUser.memberType ?? PaymoneyMemberType.DEFAULT
                state.payMoney.bankName = PaymoneyDisplayBankNameMap[state.payMoney.bankCode]
            })
            .addCase(getShoppingSubscriptionResultInfo.fulfilled, (state, {payload: {subscriptionResultViewInfo}}) => {
                /** 아래 state의 initial 값이 NOT_OPEN  */
                state.payMoney.userStatus = subscriptionResultViewInfo.chargePointUser.userStatus ?? 'NOT_OPEN'
            })
    },
})

export default slice.reducer
export const actions = slice.actions
